import * as scene from '@ps/bridge/qc/node/scene'
import { getSceneUniName, SceneType } from '@ps/bridge/qc/scripts/scene-config'
import {
  initIvScene,
  generateBrainItem,
  linkBrainItem,
  addSceneHotSpot,
  switchIvSegmentBrainData,
  isSceneToSceneSpot,
  getSceneHotSpotGroup,
  checkIsRootBrainItem,
  checkCanAddBrainItem,
} from './brain'
import { IvBrain, IvBrainItem, NodeAction, NodeActionInfo } from './types'
import { IvLinkType } from './enums'
import { getScript } from '@ps/bridge/qc/scripts/scene-config'
import store from '@ps/store'
import { EventBus, Event } from '@ps/utils/event-bus'
import _ from 'lodash'
import {
  IvLoopSubType,
  IvSegmentType,
} from '@ps/store/interactive-video/timeline/enums'
import {
  addSegmentIvToSceneByStore,
  addEndSegmentToScene,
  updateSegmentIvTypeToScene,
  removeSegmentIvToScene,
  updateSegmentToScene,
} from '@ps/store/interactive-video/timeline/utiles/scene'
import qc from 'qc'
import nodePool from '@ps/bridge/qc/node-pool'
import * as sceneConfigScript from '@ps/bridge/qc/scripts/scene-config'
import { Message } from 'element-ui'
import i18n from '@ps/lang'
import {
  executeAction,
  getAddIvSegmentAction,
  getSwitchIvSegmentAction,
  getAddBrainItemAction,
  getDeleteBrainItemAction,
  getPasteBrainItemAction,
} from '@ps/workbench/undo-redo'
import { pushIVRecordAction } from '@ps/store/interactive-video/state-action'
import {
  getBrainItemAllChildren,
  getParentBrainItem,
  deleteBrainItemAction,
  addBrainItemByBrain,
  getBrainItemByUuid,
  checkCanAddResource,
  emptyBrain,
} from '@ps/store/interactive-video/brain/brain'
import { useTrackGroupInsertResults } from '@ps/store/interactive-video/timeline/utiles/track-group-insert'
import { getOldNodeData } from '@ps/store/interactive-video/timeline/action'
import {
  getAddSceneAction,
  getRemoveSceneAction,
} from '@ps/workbench/undo-redo'
import { getRemoveSceneConfig } from '@ps/bridge/qc/node'
import { RemoveSceneActionValue } from '@ps/workbench/undo-redo/module/scene-action'
import { deepReplaceAstUUID } from '@ps/store/interactive-video/common/utils'
import {
  getTimelineBySceneUuid,
  setTimeline,
} from '@ps/store/interactive-video/timeline/timeline'
import { isSceneError } from '@ps/store/interactive-video/timeline/utiles/scene-error'
import { VpMethods } from '@ps/bridge/qc/vp/config'

export default {
  getInitBrain({ commit }) {
    const gamePlay = store.state.workspace.game.gamePlay
    const ped = gamePlay.getScript('playsmart.editor.data')
    commit('updateBrainData', ped.$data.brain || [])
  },
  initBrain({ rootState, commit }) {
    EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
    EventBus.$emit(Event.IV_BRAIN_INIT)
    EventBus.$emit(Event.IV_BRAIN_CHANGE)
  },
  switchIvSegment(
    { state, commit, rootState },
    { type, interactiveType, nodeUuid, sceneUuid, record },
  ) {
    const cloneBrain: IvBrainItem[] = _.cloneDeep(store.state.ivBrain.brainData)
    const brainItem: IvBrainItem | undefined = getBrainItemByUuid(
      sceneUuid,
      cloneBrain,
    )
    const spotAction: NodeAction = { action: '', spots: [] }
    const nodeActionInfo: NodeActionInfo[] = []
    if (!brainItem) return
    // useTrackGroupInsertResults 函数体内需要保证操作同步
    let fail = false
    const groupInsertResults = useTrackGroupInsertResults(sceneUuid, () => {
      if (interactiveType === IvSegmentType.Loop) {
        // 切成互动循环时需要初始成单向循环
        updateSegmentToScene(sceneUuid, nodeUuid, {
          loopSubType: IvLoopSubType.Single,
        })
      } else {
        updateSegmentToScene(sceneUuid, nodeUuid, {
          loopSubType: undefined,
        })
      }
      if (isSceneToSceneSpot(nodeUuid, brainItem)) {
        // 场景间互动元件切换
        const res = switchIvSegmentBrainData({
          nodeUuid: nodeUuid,
          sceneUuid: sceneUuid,
          type,
          interactiveType,
          brainData: brainItem,
        })
        // 根据res返回值做历史记录 to do
        spotAction.action = res.spotAction.action
        spotAction.spots = res.spotAction.spots
        commit('updateBrainData', cloneBrain)
        if (res.fail) {
          fail = true
        }
      } else {
        // 场景内互动元件切换
        updateSegmentIvTypeToScene({
          nodeUuid,
          sceneUuid,
          type: interactiveType,
        })
      }
    })
    if (fail) {
      return
    }
    if (spotAction.action && spotAction.spots.length) {
      spotAction.spots.forEach((item) => {
        nodeActionInfo.push({
          node: item,
          parent: item.parent,
          index: item.parent.getChildIndex(item),
        })
      })
    }
    const linkNode = nodePool.find(brainItem.link.id)

    executeAction({
      action: getSwitchIvSegmentAction({
        newValue: {
          groupInsertResults,
          nodeActionInfo,
          spotAction,
          linkNode,
        },
        oldValue: {
          spotAction: {
            ...spotAction,
            action: spotAction.action === 'add' ? 'delete' : 'add',
          },
          groupInsertResults,
          nodeActionInfo,
          linkNode,
          oldNodeData: getOldNodeData(groupInsertResults),
        },
      }),
      record,
    })
    EventBus.$emit(Event.IV_BRAIN_CHANGE)
  },
  async addBrainItem(
    { state, rootState, commit },
    { pid, record = true, isSwitchScene = true, isEnd = false },
  ) {
    // 结束场景异常判断
    if (pid && !checkCanAddBrainItem(pid)) return
    const sceneList = rootState.workspace.game.sceneManager.sceneList
    const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
    const spotList: qc.Node[] = []
    const spotInfo: NodeActionInfo[] = []
    // 添加场景节点
    const sceneNode = scene.add({
      uniqueName: getSceneUniName(sceneList, SceneType.NORMAL),
    })

    const res = await initIvScene(rootState, sceneNode, isEnd)
    // addBrain
    commit('addBrainItem', generateBrainItem(sceneNode, res.linkNode, isEnd))
    // 连线操作
    if (pid) {
      const brainData = _.cloneDeep(rootState.ivBrain.brainData)
      const linkData = linkBrainItem(pid, sceneNode.uuid, brainData)
      if (linkData.hotSpot) {
        const curBrain = brainData.find(
          (item) => item.sceneUuid === sceneNode.uuid,
        )
        addEndSegmentToScene(sceneNode.uuid, curBrain.link)
        spotList.push(linkData.hotSpot)
      }
      commit('updateBrainData', brainData)
    }
    if (spotList.length) {
      spotList.forEach((item) => {
        spotInfo.push({
          node: item,
          parent: item.parent,
          index: item.parent.getChildIndex(item),
        })
      })
    }
    executeAction({
      action: getAddBrainItemAction({
        dependAction: getAddSceneAction({
          newValue: {
            node: sceneNode,
            // 如果index为undefined的话，则加载最后面
            index: sceneList.length,
            isSwitchScene: true,
            sceneType: SceneType.NORMAL,
          },
          oldValue: {
            node: sceneNode,
            sceneUuid: currentSceneNode ? currentSceneNode.uuid : '',
          },
        }),
        newValue: {
          nodeAction: {
            action: 'add',
            spots: spotList,
          },
          nodeActionInfo: spotInfo,
        },
        oldValue: {
          nodeAction: {
            action: 'delete',
            spots: spotList,
          },
          nodeActionInfo: spotInfo,
        },
      }),
      record,
    })
  },
  deleteBrainItem({ state, rootState, commit }, { uuid, record = true }) {
    const brainData = rootState.ivBrain.brainData
    const brain = brainData.find((item: IvBrainItem) => item.sceneUuid === uuid)
    if (checkIsRootBrainItem(brain ? brain.sceneUuid : '')) {
      return
    }
    if (brain) {
      const allBrain = getBrainItemAllChildren(brain)
      const pBrain = getParentBrainItem(brain)
      const spotInfo: NodeActionInfo[] = []

      store.dispatch('workspace/sceneManager/switchScene', {
        uuid: pBrain ? pBrain.sceneUuid : '',
        record: false,
      })

      // 互动跳转需要删除热区
      const hotSpot = deleteBrainItemAction(
        pBrain ? pBrain.sceneUuid : '',
        brain.sceneUuid,
        allBrain.map((el) => el.sceneUuid),
      )

      if (hotSpot) {
        spotInfo.push({
          node: hotSpot,
          parent: hotSpot.parent,
          index: hotSpot.parent.getChildIndex(hotSpot),
        })
      }

      const removeSceneConfigs: RemoveSceneActionValue[] = allBrain.map(
        (item) => {
          const scene = nodePool.find(item.sceneUuid)
          const config = getRemoveSceneConfig(
            scene,
            pBrain ? pBrain.sceneUuid : '',
          )
          return config
        },
      )

      executeAction({
        action: getDeleteBrainItemAction({
          dependAction: getRemoveSceneAction(removeSceneConfigs),
          newValue: {
            nodeAction: {
              action: 'delete',
              spots: hotSpot ? [hotSpot] : [],
            },
            nodeActionInfo: spotInfo,
          },
          oldValue: {
            nodeAction: {
              action: 'add',
              spots: hotSpot ? [hotSpot] : [],
            },
            nodeActionInfo: spotInfo,
          },
        }),
        record,
      })
    }
  },

  emptyBrainItem({ state, rootState, commit }, { videoNodes, record = true }) {
    const brainData = _.cloneDeep(rootState.ivBrain.brainData)
    const toRemoveNodes: qc.Node[][] = []
    videoNodes.forEach((node) => {
      const brain = brainData.find(
        (item: IvBrainItem) => item.videoUuid === node.uuid,
      )
      if (brain) {
        const removeNodes = emptyBrain(brain)
        toRemoveNodes.push([node].concat(removeNodes))
      }
    })
    commit('updateBrainData', brainData)
    EventBus.$emit(Event.IV_BRAIN_CHANGE)
  },
  copyBrainItem({ state, rootState, commit }, { uuid, record = true }) {
    console.log('copy-brain')
    commit('updateCopyId', uuid)
  },
  async pasteBrainItem(
    { state, rootState, commit },
    { uuid, targetUuid, record = true },
  ) {
    const pasteUuid = uuid || state.copyBrainSceneUuid
    // 异常判断
    if (targetUuid && !checkCanAddBrainItem(targetUuid)) return
    const brainData = _.cloneDeep(rootState.ivBrain.brainData)
    const pasteBrain = getBrainItemByUuid(pasteUuid, brainData)
    const targetBrain = getBrainItemByUuid(targetUuid, brainData)
    if (pasteBrain && targetBrain) {
      // store.dispatch('workspace/sceneManager/switchScene', {
      //   uuid: pBrain.sceneUuid,
      //   record: false,
      // })
      store.commit('workspace/lockPage')
      const res = await addBrainItemByBrain(
        [pasteBrain],
        targetBrain,
        brainData,
        [], // init new sceneList
        [], // init new spotList
        true,
      )
      res.sceneList.forEach((item) => {
        const brain = getBrainItemByUuid(item.uuid, brainData)
        deepReplaceAstUUID({
          vpAst: brain,
          sceneNode: item,
          ignoreKey: ['targetUuid', 'sceneUuid'],
        })
        const ast = item.getScript('playsmart.editor.data').vpAst
        // 克隆出来的场景里的场景跳转参数需要替换成新的
        for (const i in ast) {
          for (const j in ast[i].action) {
            if (ast[i].action[j].method === VpMethods.vpSwitchScene) {
              const action = brain.actions.find(
                (action) => action.nodeUuid === ast[i].action[j].node,
              )
              if (action) {
                ast[i].action[j].param.jumpSceneId = action.targetUuid
              }
            }
          }
        }
        item.getScript('playsmart.editor.data').vpAst = ast
        const timeline = getTimelineBySceneUuid(item.uuid)
        deepReplaceAstUUID({ vpAst: timeline, sceneNode: item })
        setTimeline(item.uuid, timeline)
      })
      const spotInfo: NodeActionInfo[] = []
      if (res.spotList) {
        res.spotList.forEach((hotSpot) => {
          spotInfo.push({
            node: hotSpot,
            parent: hotSpot.parent,
            index: hotSpot.parent.getChildIndex(hotSpot),
          })
        })
      }
      commit('updateBrainData', brainData)
      EventBus.$emit(Event.IV_BRAIN_CHANGE)
      executeAction({
        action: getPasteBrainItemAction({
          newValue: {
            nodeAction: {
              action: 'add',
              spots: res.spotList ? res.spotList : [],
            },
            nodeActionInfo: spotInfo,
          },
          oldValue: {
            nodeAction: {
              action: '',
              spots: [],
            },
            nodeActionInfo: spotInfo,
          },
        }),
        record,
      })
    }
  },
  // 添加场景内互动元件
  async addIvSegment({ state, commit, rootState }, { type, record = true }) {
    const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
    const brainItem: IvBrainItem | undefined = getBrainItemByUuid(
      currentSceneNode ? currentSceneNode.uuid : '',
    )
    if (!checkCanAddResource(currentSceneNode.uuid, 'iv-segment')) return
    const spotGroup = getSceneHotSpotGroup(currentSceneNode) as qc.Node
    const hotSpot = addSceneHotSpot(currentSceneNode.uuid)
    const gameState = store.state.workspace.game
    if (hotSpot) {
      const res = addSegmentIvToSceneByStore({
        nodeUuid: hotSpot.uuid,
        sceneUuid: currentSceneNode.uuid,
        type,
      })
      if (isSceneError(res)) {
        hotSpot.removeSelf()
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000,
        })
        return
      }
      updateSegmentToScene(currentSceneNode.uuid, hotSpot.uuid, {
        groupId: spotGroup.uuid,
      })
    }

    executeAction({
      action: getAddIvSegmentAction({
        newValue: {
          node: hotSpot,
          parent: spotGroup,
          index: spotGroup.children.length - 1,
        },
        oldValue: {
          node: hotSpot,
          activeUuid: gameState.activeNode ? gameState.activeNode.uuid : '',
        },
      }),
      record,
    })
  },
  bindVideo({ state, commit }, { sceneUuid, uuid }) {
    const data = _.cloneDeep(state.brainData)
    const brainData = data.find((item) => item.sceneUuid === sceneUuid)
    if (brainData) {
      brainData.videoUuid = uuid
    }
    EventBus.$emit(Event.IV_GUIDE_STEP, 3)
    commit('updateBrainData', data)
    // pushIVRecordAction()
  },
}
